
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13540",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13540",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1161",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10131",
  "foundations-components": "static-1.8776",
  "foundations-components-legacy": "static-1.1801",
  "foundations-theming": "static-1.4982",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.95",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8531",
  "hub-http-shared-msw-handlers": "static-1.10931",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11979",
  "I18n": "static-7.1712",
  "jasmine-runner": "static-1.6945",
  "marketplace-discovery-studio-lib": "static-1.935",
  "marketplace-storefront-base": "static-1.13603",
  "quartz": "static-1.7687",
  "react-dlb": "static-1.96",
  "react-rhumb": "static-1.17231",
  "reactive-variable-buffer-atom": "static-1.3344",
  "reporting-testing-lib": "static-1.11347",
  "reselect": "static-3.18",
  "settings-ui-lib": "static-1.13020",
  "SharedI18nStrings": "static-1.190",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7876",
  "ui-addon-i18n": "static-1.11637",
  "ui-addon-react-router-dom": "static-1.10017",
  "unified-auth": "static-1.1287",
  "unified-auth-core-lib": "static-1.1569",
  "usage-tracker": "static-1.7815",
  "usage-tracker-core": "static-1.7665",
  "customer-data-property-utils": "static-1.8544",
  "hub-http": "static-1.6698",
  "integrations-lib": "static-1.17467",
  "marketplace-ui-common": "static-1.21053",
  "marketplace-ui-install": "static-1.1039",
  "property-management-iframe": "static-1.14488",
  "quartz-config": "static-1.1465",
  "quartz-core": "static-1.6906",
  "quartz-routing": "static-1.1117",
  "quick-fetch": "static-1.4240",
  "react": "static-7.204",
  "rpc-client-utils": "static-1.5161",
  "ts-schema": "static-1.4404",
  "ui-universal-auth": "static-1.9773",
  "UIComponents": "static-3.8925",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3964",
  "quartz-webpack": "static-1.3911",
  "bend-plugin-quartz-routing": "static-1.765",
  "ai-components-ui-library": "static-1.10053",
  "codemirror": "static-5.108",
  "foundations-assets": "static-1.5380",
  "pulse": "static-1.1141",
  "react-codemirror": "static-1.11134",
  "ui-extensions-preview-lib": "static-1.1012",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5045",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2698",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9921",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.108",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5671",
  "react-virtualized": "static-2.114",
  "StyleGuideUI": "static-3.520",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3129",
  "ui-fonts": "static-1.1241",
  "ui-images": "static-2.1281",
  "bend-plugin-foundations-theming": "static-1.3465",
  "foundations-theming-base": "static-1.3967",
  "stylex": "static-1.48",
  "HeadJS": "static-2.826",
  "hs-test-utils-bend-plugin": "static-1.3642",
  "msw": "static-1.105",
  "msw-config": "static-1.32",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4798",
  "ui-addon-video-player": "static-1.9115",
  "ai-rendering-library": "static-1.11431",
  "chirp-fetch": "static-1.2397",
  "connections-embed-lib": "static-1.1783",
  "copilot-toolkit": "static-1.12183",
  "feedback-loader": "static-1.30086",
  "laboratory-lib": "static-3.7639",
  "marketplace-embed": "static-1.23232",
  "marketplace-ui-details": "static-1.10948",
  "marketplace-ui-reviews": "static-1.21008",
  "marketplace-ui-tracking": "static-1.15223",
  "sanitize-text": "static-1.8650",
  "usage-tracker-multi": "static-1.6229",
  "usage-tracker-session-replay": "static-1.5501",
  "beacon-keepalive-queue": "static-1.192",
  "quartz-head": "static-1.1352",
  "web-vitals": "static-1.21",
  "apollo-link-hub-http": "static-2.5081",
  "immer": "static-1.107",
  "immerable": "static-1.4634",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2852",
  "reporting-data": "static-1.69414",
  "cssUtils": "static-1.1115",
  "flux-actions": "static-1.383",
  "react-colorpicker": "static-2.10702",
  "react-dnd-compat": "static-1.5102",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10862",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7805",
  "icons": "static-2.707",
  "marketplace-ui-apps-core": "static-1.19585",
  "storybook-react": "static-1.46",
  "trellis-story-utils": "static-1.4990",
  "foundations-components-test-utils": "static-1.6259",
  "quartz-i18n": "static-1.1362",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.788",
  "ads-unified-auth-lib": "static-1.2066",
  "ai-mcp-auth-lib": "static-1.38",
  "custom-vendor-connection-lib": "static-1.337",
  "gemini-settings-lib": "static-1.9815",
  "google-sheets-integration-lib": "static-1.1363",
  "microsoft-drive-auth-lib": "static-1.571",
  "slack-ui-library": "static-1.10891",
  "surveymonkey-integration-lib": "static-1.894",
  "fsm": "static-1.4249",
  "customer-data-objects": "static-1.8199",
  "property-translator": "static-1.5872",
  "hs-locale-management": "static-1.411",
  "frontend-preferences-client": "static-1.8414",
  "hs-promise-utils": "static-1.6084",
  "hubspot-apollo-client": "static-1.5375",
  "integrations-error-boundary-lib": "static-1.14882",
  "integrations-tracking-lib": "static-1.6115",
  "native-integrations-shared-strings": "static-1.8255",
  "sanitize": "static-1.4967",
  "superstore": "static-1.5250",
  "ui-shepherd-react": "static-3.10772",
  "ai-settings-ui-library": "static-1.8619",
  "hub-http-janus": "static-1.910",
  "hubspotter-http": "static-1.4984",
  "immutable-less": "static-1.5144",
  "marketplace-ui-client-types": "static-1.18460",
  "nav-meta": "static-1.30840",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18554",
  "ui-product-approvals-common": "static-1.1628",
  "ai-studio-lib": "static-1.12805",
  "hubspot-prosemirror": "static-1.19312",
  "integrations-reconnect-lib": "static-1.756",
  "ui-addon-iframeable": "static-1.9570",
  "ui-addon-integrations-directory-panel": "static-2.8446",
  "ui-product-approvals": "static-1.29733",
  "ui-tool-access": "static-1.10650",
  "inbound-db-properties-service-client": "static-1.4160",
  "property-management-common": "static-1.6776",
  "opentelemetry-fe-types": "static-1.283",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.609",
  "module-federation": "static-1.41",
  "opentelemetry-fe": "static-1.658",
  "quartz-auth": "static-1.1362",
  "quartz-test": "static-1.1362",
  "quartz-tracking": "static-1.1066",
  "trellis-components": "static-1.3148",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.571",
  "HubStyle": "static-2.12286",
  "bender-build-tools": "static-1.3604",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23987",
  "ContentUtils": "static-1.69514",
  "customer-data-objects-ui-components": "static-1.13527",
  "sassPrefix": "static-1.380",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2041",
  "bend-plugin-pulse": "static-1.644",
  "event-emitter": "static-1.1454",
  "fast-json-patch": "static-1.76",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5922",
  "magpie-types": "static-1.5382",
  "stylex-utils": "static-1.179",
  "trellis-theming": "static-1.1506",
  "avatar-components": "static-1.2979",
  "breeze-engine-core": "static-1.1519",
  "breeze-engine-lib": "static-1.2241",
  "breeze-onboarding-components": "static-1.1099",
  "customer-data-filters-ui": "static-1.41424",
  "customer-data-reference-ui-components": "static-1.13666",
  "data-integrations-breeze": "static-1.363",
  "embedded-academy-lib": "static-1.16054",
  "ExportDialog": "static-6.10865",
  "global-styles-ai-lib": "static-1.524",
  "highlight.js": "static-1.92",
  "marketplace-embed-ba": "static-1.935",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.47",
  "reporting-action-components": "static-1.42440",
  "reporting-snowflake": "static-1.58030",
  "reporting-ui-components": "static-2.66683",
  "reporting-visualizations": "static-1.61488",
  "trial-components-library": "static-1.14410",
  "ui-addon-teams": "static-1.22030",
  "upgrade-components-lib": "static-1.747",
  "navigation-components": "static-1.19203",
  "nest": "static-1.728",
  "simple-logging-lib": "static-1.3543",
  "nudge-client-utils": "static-1.3449",
  "fail-safe": "static-1.442",
  "app-governance-lib": "static-1.2772",
  "developer-experience-shared-components": "static-1.11033",
  "purchase-motions-components": "static-1.6654",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10828",
  "usage-tracker-anonymous": "static-1.6232",
  "usage-tracker-public": "static-1.7626",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3784",
  "persist-promise": "static-1.4198",
  "reference-resolvers": "static-1.8677",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4407",
  "hubspot-apollo-cache": "static-1.834",
  "universal-page-editor-lib": "static-1.3505",
  "final-form": "static-1.85",
  "redux-toolkit": "static-1.84",
  "simple-data-table": "static-1.3853",
  "merchandise-lib": "static-1.288",
  "onboarding-scopes": "static-1.6946",
  "ui-addon-draggable": "static-3.5241",
  "content-assistance-lib": "static-1.8446",
  "content-media-capture": "static-1.5824",
  "customer-data-ui-utilities": "static-1.10324",
  "emoji-mart": "static-3.9",
  "file-manager-components": "static-1.24867",
  "growth-payments-core": "static-1.26534",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3375",
  "payment-link-components": "static-1.24491",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20581",
  "ui-addon-emoji-picker": "static-1.10355",
  "ui-business-units-lib": "static-1.9589",
  "video-components-external": "static-1.12476",
  "video-data-lib": "static-1.36134",
  "navigation-messaging": "static-1.8530",
  "collaboration-sidebar": "static-1.59090",
  "trellis-ext-dnd": "static-1.569",
  "crm-component-utils": "static-1.40234",
  "crm-properties-common-lib": "static-1.6389",
  "customer-data-properties": "static-1.53105",
  "external-options-client-types": "static-1.4448",
  "hs-resources": "static-1.675",
  "property-value-citations": "static-1.3719",
  "reference-resolvers-lite": "static-1.8605",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10929",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "cms-field-types": "static-1.5302",
  "content-icons-ui": "static-1.2474",
  "atom": "static-1.5564",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1213",
  "trellis-migration-context": "static-1.73",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1219",
  "breeze-artifacts-sdk": "static-1.1045",
  "getting-started-shared-tasks": "static-1.19595",
  "onboarding-journeys-lib": "static-1.1261",
  "conversations-skeleton-state": "static-1.7611",
  "crm-message-bus": "static-1.44143",
  "customer-data-filters-ui-msw-helpers": "static-1.23859",
  "events-data-lib": "static-1.739",
  "FormUrlGenerator": "static-2.5206",
  "framework-builder-read-service-client": "static-1.4345",
  "multi-account-reference-resolvers": "static-1.1504",
  "onboarding-tours": "static-1.17412",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14800",
  "segments-client-types": "static-1.12227",
  "academy-common-lib": "static-1.15515",
  "dashboard-lib": "static-1.83345",
  "hubspot-prosemirror-plugins": "static-1.19304",
  "share-with-third-party-component-lib": "static-1.9203",
  "ui-asset-management-lib": "static-1.11593",
  "user-context": "static-1.5546",
  "reporting-plugins": "static-1.11019",
  "reporting-reports": "static-1.69090",
  "hubs-service-types": "static-1.1760",
  "purchase-motions-api": "static-1.6657",
  "salesImages": "static-1.750",
  "signup-constants": "static-1.19975",
  "nudge-custom-function-registry": "static-1.3206",
  "nudge-renderer-utils": "static-1.3525",
  "whisper-core-api": "static-1.7669",
  "bend-plugin-fail-safe": "static-1.393",
  "framework-listing-lib": "static-2.29844",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31783",
  "apps-service-types": "static-1.4101",
  "oauth-service-types": "static-1.4628",
  "signup-ui-url-generator": "static-2.8530",
  "onboarding-tours-client": "static-1.5627",
  "one-click-checkout": "static-1.767",
  "platform-infra-nav-components": "static-1.8011",
  "subscription-experience-data-types": "static-1.15459",
  "crm-record-cards-client": "static-1.93",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7385",
  "location-customization-utils-lib": "static-1.10454",
  "redux-thunk": "static-2.86",
  "react-flip-move": "static-1.85",
  "ui-coaching-tips": "static-1.29601",
  "content-media-composition-data-lib": "static-1.13628",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4921",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3970",
  "seat-types-lib": "static-1.1077",
  "ui-addon-opt": "static-4.8907",
  "commerce-tours-lib": "static-1.6886",
  "growth-onboarding-reliability": "static-1.5576",
  "sales-checkout-service-client": "static-1.4013",
  "data-token-picker": "static-1.17161",
  "FileManagerLib": "static-1.40507",
  "content-media-compositions": "static-2.17635",
  "media-bridge-lib": "static-1.19667",
  "chatspot-widget-iframe": "static-1.23978",
  "collaboration-sidebar-common": "static-1.3887",
  "marketing-platform-lib": "static-1.7398",
  "dnd-kit": "static-1.23",
  "commerce-subscription-lib": "static-1.38086",
  "crm-actions": "static-1.6874",
  "crm-cards-sdk": "static-1.45064",
  "customer-data-properties-shared-msw-handlers": "static-1.10258",
  "customer-data-tracking": "static-1.7365",
  "calling-global-api": "static-1.66237",
  "calling-internal-common": "static-1.31817",
  "calling-lifecycle-internal": "static-1.67619",
  "calling-lifecycle-messages": "static-1.59911",
  "commerce-products-lib": "static-1.10952",
  "conditional-properties-service-client": "static-1.4122",
  "crm-index-visualization-core": "static-1.4781",
  "crm-links": "static-1.6805",
  "crm-pipelines-api-client-types": "static-1.4453",
  "data-agent-utils": "static-1.964",
  "formula-editor": "static-1.15032",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4524",
  "meetings-icalendar-utils-lib": "static-1.1124",
  "multi-currency-client-types": "static-1.4018",
  "object-builder-ui-client": "static-1.50089",
  "pipeline-validation-client-types": "static-1.4293",
  "smart-data-capture-core": "static-1.518",
  "tiered-pricing": "static-1.2311",
  "topics-actions-lib": "static-1.676",
  "trellis-ext-i18n": "static-1.1413",
  "ui-addon-form-validation": "static-1.11350",
  "zustand": "static-1.91",
  "fdsr-migration-layer": "static-1.504",
  "restore-request-side-panel-lib": "static-1.2062",
  "growth-data-modal": "static-1.6160",
  "growth-onboarding-confetti": "static-1.3550",
  "growth-onboarding-next-action-utils": "static-1.3016",
  "onboarding-tours-utils": "static-1.1479",
  "ui-shepherd-tracker": "static-1.8153",
  "crm-index-associations-lib": "static-1.6940",
  "academy-service-client": "static-1.4184",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40366",
  "SafeStorage": "static-1.4888",
  "video-embed": "static-1.36968",
  "wootric-nps": "static-1.7307",
  "redux-actions": "static-3.76",
  "EmailSignatureEditor": "static-1.25277",
  "viral-links-lib": "static-1.7575",
  "nested-table": "static-1.724",
  "timezone-utils": "static-2.5723",
  "getting-started-shared-tasks-store": "static-1.18713",
  "campaign-roi-lib": "static-1.10870",
  "campaigns-utils-lib": "static-1.3742",
  "ui-addon-calendars": "static-2.5858",
  "customer-data-views-management": "static-1.26386",
  "framework-data-table": "static-2.12868",
  "nudge-custom-ui-functions": "static-1.1763",
  "switchboard-lib": "static-1.729",
  "access-check-ui-lib": "static-1.1915",
  "app-users-service-client": "static-1.6113",
  "app-users-service-types": "static-1.5521",
  "mini-checkout-client": "static-1.27862",
  "onboarding-utils": "static-1.5866",
  "permissions-shared-i18n-strings-fe": "static-1.2145",
  "ui-coaching-tips-shared-config": "static-1.29586",
  "checkout-sdk": "static-3.24705",
  "payment-method-components": "static-1.7336",
  "touchless-buying-components": "static-1.6573",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.884",
  "framework-data-schema-quick-fetch": "static-1.7290",
  "growth-onboarding-feedback-components": "static-1.7073",
  "audio-components": "static-1.6596",
  "FileManagerImages": "static-1.38018",
  "video-components": "static-1.14478",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20525",
  "commerce-shared-components-lib": "static-1.19604",
  "commerce-tools-ui-lib": "static-1.11352",
  "crm_data": "static-4.93239",
  "crm-activity-creator-data": "static-1.47775",
  "crm-fe-perf": "static-1.23391",
  "universal-record-utils-lib": "static-1.2401",
  "calling-error-reporting": "static-1.31824",
  "shared-worker-versioning": "static-1.11536",
  "calling-usage-tracker": "static-1.7033",
  "voice-sms-access-library": "static-1.2499",
  "commerce-permissions": "static-1.1278",
  "products-iframe-lib": "static-1.8947",
  "products-ui-components-shared-msw-handlers": "static-1.11313",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11014",
  "sales-views-client-types": "static-1.4751",
  "data-agent-kit": "static-1.951",
  "enrichment-settings-lib": "static-1.267",
  "policy-lib": "static-1.7296",
  "bark-lib": "static-1.17026",
  "browser-prettier": "static-1.11",
  "onboarding-data-sync-lib": "static-1.2863",
  "growth-onboarding-next-action-components": "static-1.3044",
  "user-context-client": "static-1.5002",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5006",
  "outpost": "static-1.4621",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22385",
  "sales-email-signature-service-client": "static-1.4341",
  "ts-utils-lib": "static-1.644",
  "copilot-messaging": "static-1.2433",
  "crm-export-dialog": "static-1.6770",
  "crm-index-ui-shimmer": "static-1.3015",
  "crm-view-components": "static-1.1535",
  "react-beautiful-dnd": "static-1.77",
  "customer-data-associations": "static-1.7830",
  "tasks-actions-lib": "static-1.465",
  "InboxConnectUtils": "static-4.15872",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.884",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4479",
  "company-details-components": "static-1.6698",
  "react-performance-metrics-lib": "static-1.1045",
  "pricing-pages-ui-components": "static-1.16649",
  "quote-checkout-service-types": "static-1.3952",
  "social-insights-client-types": "static-1.22959",
  "utility-belt": "static-1.3030",
  "payments-enrollment-embed-lib": "static-1.24249",
  "stripe-embedded-components": "static-1.8273",
  "customer-data-rte": "static-1.33931",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6561",
  "payments-post-enroll-local-storage-lib": "static-1.5598",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39201",
  "crm_universal": "static-1.22751",
  "customer-data-email": "static-1.18668",
  "meetings-rte-lib": "static-1.570",
  "universal-associations-select": "static-1.11589",
  "crm-object-search-query-utilities": "static-1.10490",
  "calling-orchestration-schema": "static-1.37276",
  "react-reducer-toolkit": "static-1.16699",
  "meetings-connect-utils-lib": "static-1.8112",
  "hub-http-contrib": "static-1.3525",
  "ui-addon-sales-email": "static-1.5694",
  "company-details-service-types": "static-1.4437",
  "segments-query-core": "static-1.1923",
  "pricing-pages-api": "static-1.16514",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29185",
  "sequences-lib": "static-1.8814",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4082",
  "meetings-core": "static-1.792",
  "sequences-client-types-lib": "static-1.8671"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13540",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1161",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10131",
  "foundations-components": "/foundations-components/static-1.8776",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1801",
  "foundations-theming": "/foundations-theming/static-1.4982",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.95",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8531",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10931",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11979",
  "I18n": "/I18n/static-7.1712",
  "jasmine-runner": "/jasmine-runner/static-1.6945",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.935",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13603",
  "quartz": "/quartz/static-1.7687",
  "react-dlb": "/react-dlb/static-1.96",
  "react-rhumb": "/react-rhumb/static-1.17231",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3344",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11347",
  "reselect": "/reselect/static-3.18",
  "settings-ui-lib": "/settings-ui-lib/static-1.13020",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7876",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11637",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10017",
  "unified-auth": "/unified-auth/static-1.1287",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1569",
  "usage-tracker": "/usage-tracker/static-1.7815",
  "usage-tracker-core": "/usage-tracker-core/static-1.7665",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8544",
  "hub-http": "/hub-http/static-1.6698",
  "integrations-lib": "/integrations-lib/static-1.17467",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21053",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1039",
  "property-management-iframe": "/property-management-iframe/static-1.14488",
  "quartz-config": "/quartz-config/static-1.1465",
  "quartz-core": "/quartz-core/static-1.6906",
  "quartz-routing": "/quartz-routing/static-1.1117",
  "quick-fetch": "/quick-fetch/static-1.4240",
  "react": "/react/static-7.204",
  "rpc-client-utils": "/rpc-client-utils/static-1.5161",
  "ts-schema": "/ts-schema/static-1.4404",
  "ui-universal-auth": "/ui-universal-auth/static-1.9773",
  "UIComponents": "/UIComponents/static-3.8925",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3964",
  "quartz-webpack": "/quartz-webpack/static-1.3911",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.765",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10053",
  "codemirror": "/codemirror/static-5.108",
  "foundations-assets": "/foundations-assets/static-1.5380",
  "pulse": "/pulse/static-1.1141",
  "react-codemirror": "/react-codemirror/static-1.11134",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1012",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5045",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2698",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9921",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.108",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5671",
  "react-virtualized": "/react-virtualized/static-2.114",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3129",
  "ui-fonts": "/ui-fonts/static-1.1241",
  "ui-images": "/ui-images/static-2.1281",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3465",
  "foundations-theming-base": "/foundations-theming-base/static-1.3967",
  "stylex": "/stylex/static-1.48",
  "HeadJS": "/HeadJS/static-2.826",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3642",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.32",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4798",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9115",
  "ai-rendering-library": "/ai-rendering-library/static-1.11431",
  "chirp-fetch": "/chirp-fetch/static-1.2397",
  "connections-embed-lib": "/connections-embed-lib/static-1.1783",
  "copilot-toolkit": "/copilot-toolkit/static-1.12183",
  "feedback-loader": "/feedback-loader/static-1.30086",
  "laboratory-lib": "/laboratory-lib/static-3.7639",
  "marketplace-embed": "/marketplace-embed/static-1.23232",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10948",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21008",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15223",
  "sanitize-text": "/sanitize-text/static-1.8650",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6229",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5501",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.192",
  "quartz-head": "/quartz-head/static-1.1352",
  "web-vitals": "/web-vitals/static-1.21",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5081",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4634",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2852",
  "reporting-data": "/reporting-data/static-1.69414",
  "cssUtils": "/cssUtils/static-1.1115",
  "flux-actions": "/flux-actions/static-1.383",
  "react-colorpicker": "/react-colorpicker/static-2.10702",
  "react-dnd-compat": "/react-dnd-compat/static-1.5102",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10862",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7805",
  "icons": "/icons/static-2.707",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19585",
  "storybook-react": "/storybook-react/static-1.46",
  "trellis-story-utils": "/trellis-story-utils/static-1.4990",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6259",
  "quartz-i18n": "/quartz-i18n/static-1.1362",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.788",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2066",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.38",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.337",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9815",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1363",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.571",
  "slack-ui-library": "/slack-ui-library/static-1.10891",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.894",
  "fsm": "/fsm/static-1.4249",
  "customer-data-objects": "/customer-data-objects/static-1.8199",
  "property-translator": "/property-translator/static-1.5872",
  "hs-locale-management": "/hs-locale-management/static-1.411",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8414",
  "hs-promise-utils": "/hs-promise-utils/static-1.6084",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5375",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14882",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6115",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8255",
  "sanitize": "/sanitize/static-1.4967",
  "superstore": "/superstore/static-1.5250",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10772",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8619",
  "hub-http-janus": "/hub-http-janus/static-1.910",
  "hubspotter-http": "/hubspotter-http/static-1.4984",
  "immutable-less": "/immutable-less/static-1.5144",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18460",
  "nav-meta": "/nav-meta/static-1.30840",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18554",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1628",
  "ai-studio-lib": "/ai-studio-lib/static-1.12805",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19312",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.756",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9570",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8446",
  "ui-product-approvals": "/ui-product-approvals/static-1.29733",
  "ui-tool-access": "/ui-tool-access/static-1.10650",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4160",
  "property-management-common": "/property-management-common/static-1.6776",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.283",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.609",
  "module-federation": "/module-federation/static-1.41",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.658",
  "quartz-auth": "/quartz-auth/static-1.1362",
  "quartz-test": "/quartz-test/static-1.1362",
  "quartz-tracking": "/quartz-tracking/static-1.1066",
  "trellis-components": "/trellis-components/static-1.3148",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.571",
  "HubStyle": "/HubStyle/static-2.12286",
  "bender-build-tools": "/bender-build-tools/static-1.3604",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23987",
  "ContentUtils": "/ContentUtils/static-1.69514",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13527",
  "sassPrefix": "/sassPrefix/static-1.380",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2041",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.644",
  "event-emitter": "/event-emitter/static-1.1454",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5922",
  "magpie-types": "/magpie-types/static-1.5382",
  "stylex-utils": "/stylex-utils/static-1.179",
  "trellis-theming": "/trellis-theming/static-1.1506",
  "avatar-components": "/avatar-components/static-1.2979",
  "breeze-engine-core": "/breeze-engine-core/static-1.1519",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2241",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1099",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41424",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13666",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.363",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16054",
  "ExportDialog": "/ExportDialog/static-6.10865",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.524",
  "highlight.js": "/highlight.js/static-1.92",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.935",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.47",
  "reporting-action-components": "/reporting-action-components/static-1.42440",
  "reporting-snowflake": "/reporting-snowflake/static-1.58030",
  "reporting-ui-components": "/reporting-ui-components/static-2.66683",
  "reporting-visualizations": "/reporting-visualizations/static-1.61488",
  "trial-components-library": "/trial-components-library/static-1.14410",
  "ui-addon-teams": "/ui-addon-teams/static-1.22030",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.747",
  "navigation-components": "/navigation-components/static-1.19203",
  "nest": "/nest/static-1.728",
  "simple-logging-lib": "/simple-logging-lib/static-1.3543",
  "nudge-client-utils": "/nudge-client-utils/static-1.3449",
  "fail-safe": "/fail-safe/static-1.442",
  "app-governance-lib": "/app-governance-lib/static-1.2772",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11033",
  "purchase-motions-components": "/purchase-motions-components/static-1.6654",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10828",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6232",
  "usage-tracker-public": "/usage-tracker-public/static-1.7626",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3784",
  "persist-promise": "/persist-promise/static-1.4198",
  "reference-resolvers": "/reference-resolvers/static-1.8677",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4407",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.834",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3505",
  "final-form": "/final-form/static-1.85",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "simple-data-table": "/simple-data-table/static-1.3853",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "onboarding-scopes": "/onboarding-scopes/static-1.6946",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5241",
  "content-assistance-lib": "/content-assistance-lib/static-1.8446",
  "content-media-capture": "/content-media-capture/static-1.5824",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10324",
  "emoji-mart": "/emoji-mart/static-3.9",
  "file-manager-components": "/file-manager-components/static-1.24867",
  "growth-payments-core": "/growth-payments-core/static-1.26534",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3375",
  "payment-link-components": "/payment-link-components/static-1.24491",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20581",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10355",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9589",
  "video-components-external": "/video-components-external/static-1.12476",
  "video-data-lib": "/video-data-lib/static-1.36134",
  "navigation-messaging": "/navigation-messaging/static-1.8530",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59090",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.569",
  "crm-component-utils": "/crm-component-utils/static-1.40234",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6389",
  "customer-data-properties": "/customer-data-properties/static-1.53105",
  "external-options-client-types": "/external-options-client-types/static-1.4448",
  "hs-resources": "/hs-resources/static-1.675",
  "property-value-citations": "/property-value-citations/static-1.3719",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8605",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10929",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "cms-field-types": "/cms-field-types/static-1.5302",
  "content-icons-ui": "/content-icons-ui/static-1.2474",
  "atom": "/atom/static-1.5564",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1213",
  "trellis-migration-context": "/trellis-migration-context/static-1.73",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1219",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1045",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19595",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1261",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7611",
  "crm-message-bus": "/crm-message-bus/static-1.44143",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23859",
  "events-data-lib": "/events-data-lib/static-1.739",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5206",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4345",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1504",
  "onboarding-tours": "/onboarding-tours/static-1.17412",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14800",
  "segments-client-types": "/segments-client-types/static-1.12227",
  "academy-common-lib": "/academy-common-lib/static-1.15515",
  "dashboard-lib": "/dashboard-lib/static-1.83345",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19304",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9203",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11593",
  "user-context": "/user-context/static-1.5546",
  "reporting-plugins": "/reporting-plugins/static-1.11019",
  "reporting-reports": "/reporting-reports/static-1.69090",
  "hubs-service-types": "/hubs-service-types/static-1.1760",
  "purchase-motions-api": "/purchase-motions-api/static-1.6657",
  "salesImages": "/salesImages/static-1.750",
  "signup-constants": "/signup-constants/static-1.19975",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3206",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3525",
  "whisper-core-api": "/whisper-core-api/static-1.7669",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.393",
  "framework-listing-lib": "/framework-listing-lib/static-2.29844",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31783",
  "apps-service-types": "/apps-service-types/static-1.4101",
  "oauth-service-types": "/oauth-service-types/static-1.4628",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8530",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5627",
  "one-click-checkout": "/one-click-checkout/static-1.767",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8011",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15459",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.93",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7385",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10454",
  "redux-thunk": "/redux-thunk/static-2.86",
  "react-flip-move": "/react-flip-move/static-1.85",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29601",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13628",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4921",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3970",
  "seat-types-lib": "/seat-types-lib/static-1.1077",
  "ui-addon-opt": "/ui-addon-opt/static-4.8907",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6886",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5576",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4013",
  "data-token-picker": "/data-token-picker/static-1.17161",
  "FileManagerLib": "/FileManagerLib/static-1.40507",
  "content-media-compositions": "/content-media-compositions/static-2.17635",
  "media-bridge-lib": "/media-bridge-lib/static-1.19667",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23978",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3887",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7398",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38086",
  "crm-actions": "/crm-actions/static-1.6874",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45064",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10258",
  "customer-data-tracking": "/customer-data-tracking/static-1.7365",
  "calling-global-api": "/calling-global-api/static-1.66237",
  "calling-internal-common": "/calling-internal-common/static-1.31817",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67619",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59911",
  "commerce-products-lib": "/commerce-products-lib/static-1.10952",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4122",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4781",
  "crm-links": "/crm-links/static-1.6805",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4453",
  "data-agent-utils": "/data-agent-utils/static-1.964",
  "formula-editor": "/formula-editor/static-1.15032",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4524",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1124",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4018",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50089",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4293",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.518",
  "tiered-pricing": "/tiered-pricing/static-1.2311",
  "topics-actions-lib": "/topics-actions-lib/static-1.676",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1413",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11350",
  "zustand": "/zustand/static-1.91",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.504",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2062",
  "growth-data-modal": "/growth-data-modal/static-1.6160",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3550",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3016",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1479",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8153",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6940",
  "academy-service-client": "/academy-service-client/static-1.4184",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40366",
  "SafeStorage": "/SafeStorage/static-1.4888",
  "video-embed": "/video-embed/static-1.36968",
  "wootric-nps": "/wootric-nps/static-1.7307",
  "redux-actions": "/redux-actions/static-3.76",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25277",
  "viral-links-lib": "/viral-links-lib/static-1.7575",
  "nested-table": "/nested-table/static-1.724",
  "timezone-utils": "/timezone-utils/static-2.5723",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18713",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10870",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3742",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5858",
  "customer-data-views-management": "/customer-data-views-management/static-1.26386",
  "framework-data-table": "/framework-data-table/static-2.12868",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1763",
  "switchboard-lib": "/switchboard-lib/static-1.729",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1915",
  "app-users-service-client": "/app-users-service-client/static-1.6113",
  "app-users-service-types": "/app-users-service-types/static-1.5521",
  "mini-checkout-client": "/mini-checkout-client/static-1.27862",
  "onboarding-utils": "/onboarding-utils/static-1.5866",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29586",
  "checkout-sdk": "/checkout-sdk/static-3.24705",
  "payment-method-components": "/payment-method-components/static-1.7336",
  "touchless-buying-components": "/touchless-buying-components/static-1.6573",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.884",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7290",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7073",
  "audio-components": "/audio-components/static-1.6596",
  "FileManagerImages": "/FileManagerImages/static-1.38018",
  "video-components": "/video-components/static-1.14478",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20525",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19604",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11352",
  "crm_data": "/crm_data/static-4.93239",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47775",
  "crm-fe-perf": "/crm-fe-perf/static-1.23391",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2401",
  "calling-error-reporting": "/calling-error-reporting/static-1.31824",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11536",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7033",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2499",
  "commerce-permissions": "/commerce-permissions/static-1.1278",
  "products-iframe-lib": "/products-iframe-lib/static-1.8947",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11313",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11014",
  "sales-views-client-types": "/sales-views-client-types/static-1.4751",
  "data-agent-kit": "/data-agent-kit/static-1.951",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.267",
  "policy-lib": "/policy-lib/static-1.7296",
  "bark-lib": "/bark-lib/static-1.17026",
  "browser-prettier": "/browser-prettier/static-1.11",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2863",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3044",
  "user-context-client": "/user-context-client/static-1.5002",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5006",
  "outpost": "/outpost/static-1.4621",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22385",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4341",
  "ts-utils-lib": "/ts-utils-lib/static-1.644",
  "copilot-messaging": "/copilot-messaging/static-1.2433",
  "crm-export-dialog": "/crm-export-dialog/static-1.6770",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3015",
  "crm-view-components": "/crm-view-components/static-1.1535",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.77",
  "customer-data-associations": "/customer-data-associations/static-1.7830",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.465",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15872",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.884",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4479",
  "company-details-components": "/company-details-components/static-1.6698",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1045",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16649",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3952",
  "social-insights-client-types": "/social-insights-client-types/static-1.22959",
  "utility-belt": "/utility-belt/static-1.3030",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24249",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8273",
  "customer-data-rte": "/customer-data-rte/static-1.33931",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6561",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5598",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39201",
  "crm_universal": "/crm_universal/static-1.22751",
  "customer-data-email": "/customer-data-email/static-1.18668",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.570",
  "universal-associations-select": "/universal-associations-select/static-1.11589",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10490",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37276",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16699",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8112",
  "hub-http-contrib": "/hub-http-contrib/static-1.3525",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5694",
  "company-details-service-types": "/company-details-service-types/static-1.4437",
  "segments-query-core": "/segments-query-core/static-1.1923",
  "pricing-pages-api": "/pricing-pages-api/static-1.16514",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29185",
  "sequences-lib": "/sequences-lib/static-1.8814",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4082",
  "meetings-core": "/meetings-core/static-1.792",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8671"
}
};
